import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../../Context/User";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSmile } from "@fortawesome/free-solid-svg-icons";

export function SubNavGestaoRespostasHelpdesk() {
    const { UserInfor } = useUserInfor();

    return (
        <>
            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (
                          tela.ID_TELA ===
                          ACESSOS.HELPDESK.TELAS.GESTAO_RESPOSTAS.ID_TELA
                      ) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <NavLink
                                      to={
                                          ACESSOS.HELPDESK.TELAS
                                              .GESTAO_RESPOSTAS.DS_PATH
                                      }
                                      exact
                                      activeClassName="active"
                                      className="menu-link"
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon
                                              icon={faQuestionCircle}
                                          />
                                      </span>
                                      <span className="menu-text">
                                          Gestão de Respostas
                                      </span>
                                  </NavLink>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}
            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (
                          tela.ID_TELA ===
                          ACESSOS.HELPDESK.TELAS.PESQUISA_SATISFACAO.ID_TELA
                      ) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <NavLink
                                      to={
                                          ACESSOS.HELPDESK.TELAS
                                              .PESQUISA_SATISFACAO.DS_PATH
                                      }
                                      exact
                                      activeClassName="active"
                                      className="menu-link"
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon icon={faSmile} />
                                      </span>
                                      <span className="menu-text">
                                          Pesquisa Satisfação
                                      </span>
                                  </NavLink>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}
        </>
    );
}
